<template src="./LogIn.html"/>
<style lang="scss" scoped src="./LogIn.scss"/>
<script>

import {SfHeading, SfAlert, SfButton, SfInput, SfLoader, SfLink} from '@storefront-ui/vue';
import Api from "@/api/Api";
import OrkRecaptcha from "@/components/Ork/OrkRecaptcha";

export default {
  name: "LogIn",
  components: {
    OrkRecaptcha,
    SfHeading,
    SfAlert,
    SfInput,
    SfButton,
    SfLoader,
    SfLink
  },
  data() {
    return {
      loading: false,
      error: null,
      valid: false,
      submitted: false,
      password: "",
      passwordBlur: true,
      email: "",
      emailBlur: true
    }
  },
  watch: {
    isLogIn() {
      this.email = ""
      this.password = ""
    },
  },
  methods: {
    executeRecaptcha() {
      this.$refs.recaptchaSignInForm.execute()
    },
    validate() {
      this.emailBlur = false;
      if (
          this.validEmail(this.email)
      ) {
        this.valid = true;
      }
    },
    validEmail(email) {
      const regex = /(.+)@(.+){2,}\.(.+){2,}/
      const hasWhiteSpace = /\s/;
      if (regex.test(email.toLowerCase()) && !hasWhiteSpace.test(email.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    },

    submitLoginForm(token) {
      const onComplete = () => {
        if (!this.error || this.error.status === 200) {
          this.loading = false;
        } else {
          this.loading = false;
        }
      };

      const onError = (e) => {
        this.error = e;
        this.loading = false;
      };
      this.validate()
      if (this.valid) {
        this.loading = true;
        this.$emit('submit', {
          form: {email: this.email, password: this.password, recaptchaData: token},
          onComplete,
          onError
        });

      }
    },
    /*
        handleLogin() {
          this.$emit('handleLogin', {email: this.email, password: this.password})
          this.loading = true
          Api.account.login({email: this.email, password: this.password})
              .then((data) => {
                this.$store.dispatch('loginCustomer', data);
                this.$store.dispatch('toggleWelcomeModal', {
                  open: true,
                  customer: data
                });
                this.$store.dispatch('toggleLoginModal',{open:false});

              })
              .catch((e) => {
                this.$store.dispatch('sendNotification', {type: 'danger', message: 'login error', icon: 'error'});
                this.error = e
              })
              .finally(() => {
                this.loading = false;
              })
        },
    */
  }
}
</script>


